/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/histogram_fraction.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Returns the estimated fraction of observations of a native histogram that fall between the provided lower and upper values.
 *
 * @example
 * histogram_fraction(0, 0.2, increase(http_request_duration_seconds[1h]))
 */
const definition: PromqlFunctionDefinition = {
  type: 'histogram',
  name: 'histogram_fraction',
  signatures: [
    {
      params: [
        {
          name: 'lower',
          type: 'scalar',
          optional: false,
          description: 'Lower bound of the range.',
        },
        {
          name: 'upper',
          type: 'scalar',
          optional: false,
          description: 'Upper bound of the range.',
        },
        {
          name: 'v',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector input.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
